export const WORDS = [
  'REACT','SLATE','CRANE','AUDIO','RAISE','ABOUT','APPLE','BEACH','CHAIR','DANCE',
  'EAGER','FLAME','GLOBE','HEART','INDEX','JOKER','KNIFE','LEMON','MAGIC','NOBLE',
  'OCEAN','PIANO','QUEEN','RIVER','SOLAR','TOWER','ULTRA','VIVID','WHEAT','XENON',
  'YACHT','ZEBRA','BLAZE','CHARM','DREAM','EQUIP','FROST','GRAPE','HOVER','IMAGE',
  'JUDGE','KNEEL','LIGHT','MANGO','NEXUS','ORBIT','PEARL','QUILT','RANGE','SHINE',
  'THINK','UNITY','VALOR','WORLD','YOUTH','ANGEL','BLOOM','CLOUD','DOUBT','EVENT',
  'FIELD','GRACE','HOUSE','IVORY','JEWEL','KARMA','LEVEL','MONTH','NIGHT','OLIVE',
  'PLANT','QUIET','ROYAL','SPACE','TIGER','UNDER','VOICE','WATCH','OXIDE','YIELD',
  'AMBER','BLINK','CRAFT','DRIVE','ELITE','FAITH','GREEN','HASTE','INNER','JOLLY',
  'KAYAK','LOGIC','MERCY','NURSE','OTHER','POWER','QUOTE','REIGN','STORM','TREND',
];

export function getRandomWord() {
  return WORDS[Math.floor(Math.random() * WORDS.length)];
}

export function isValidWord(word) {
  return WORDS.includes(word.toUpperCase());
}
